module.exports = __webpack_public_path__ + "img/profess2.8eb40870.png";